import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import ReportApi from '../server/ReportApi';


function createSuccessHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.data
            });
        });
    }
}

function createErrorHandler() {
    let actions = Array.from(arguments);
    return function(response) {
        actions.forEach(function(action) {
            CentricDispatcher.dispatch({
                type: action,
                data: response.message
            });
        });
    }
}

const _handleFormError = createErrorHandler(ActionTypes.FORM_SUBMIT_ERROR);
const _handleException = createErrorHandler(ActionTypes.API_EXCEPTION);


export default {

    getAll: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_LIST);
        const handleError = createErrorHandler(ActionTypes.REPORT_LIST_ERROR);

        // get all notifications from the server
        return ReportApi.getAll(params)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    getById: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_INFO);
        const handleError = createErrorHandler(ActionTypes.REPORT_INFO_ERROR);

        return ReportApi.getById(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    save: function(entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_SAVE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.REPORT_INFO_ERROR);

        return ReportApi.save(entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    update: function(id, entity) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_UPDATE, ActionTypes.FORM_SUBMIT_SUCCESS);
        const handleError = createErrorHandler(ActionTypes.REPORT_UPDATE_ERROR);

        return ReportApi.update(id, entity)
            .then(handleSuccess, _handleFormError)
            .catch(handleError);
    },

    delete: function(id) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_DELETE);
        const handleError = createErrorHandler(ActionTypes.REPORT_DELETE_ERROR);

        return ReportApi.delete(id)
            .then(handleSuccess, handleError)
            .catch(handleError);
    },

    search: function(searchText) {
        const handleSuccess = createSuccessHandler(ActionTypes.SEARCH_RESULT_RECEIVED);
        const handleError = createErrorHandler(ActionTypes.SEARCH_ERROR);

        return ReportApi.search(searchText)
            .then(handleSuccess, handleError);
    },

    getResults: function(params) {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_RESULTS);
        const handleError = createErrorHandler(ActionTypes.REPORT_RESULTS_ERROR);

        return ReportApi.getResults(params)
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    getSharedResults: (key) => {
        const types = {
            request: ActionTypes.REPORT_SHARE_RESULTS_REQUEST,
            success: ActionTypes.REPORT_SHARE_RESULTS_SUCCESS,
            failure: ActionTypes.REPORT_SHARE_RESULTS_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.getSharedResults(key), types, {key});
    },

    getReportTypes: function() {
        const handleSuccess = createSuccessHandler(ActionTypes.REPORT_TYPE_LIST);
        const handleError = createErrorHandler(ActionTypes.REPORT_TYPE_LIST_ERROR);

        return ReportApi.getReportTypes()
            .then(handleSuccess, handleError)
            .catch(_handleException);
    },

    emailResults: (id, params) => {
        const types = {
            request: ActionTypes.REPORT_EMAIL_REQUEST,
            success: ActionTypes.REPORT_EMAIL_SUCCESS,
            failure: ActionTypes.REPORT_EMAIL_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.emailResults(id, params), types, {id, params});
    },

    getShare: (reportId, suppressErrors = false) => {
        const types = {
            request: ActionTypes.REPORT_SHARE_INFO_REQUEST,
            success: ActionTypes.REPORT_SHARE_INFO_SUCCESS,
            failure: ActionTypes.REPORT_SHARE_INFO_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.getShare(reportId), types, {reportId, suppressErrors});
    },

    addShare: (reportId) => {
        const types = {
            request: ActionTypes.REPORT_SHARE_ADD_REQUEST,
            success: ActionTypes.REPORT_SHARE_ADD_SUCCESS,
            failure: ActionTypes.REPORT_SHARE_ADD_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.addShare(reportId), types, {reportId});
    },

    deleteShare: (shareKey) => {
        const types = {
            request: ActionTypes.REPORT_SHARE_DELETE_REQUEST,
            success: ActionTypes.REPORT_SHARE_DELETE_SUCCESS,
            failure: ActionTypes.REPORT_SHARE_DELETE_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.deleteShare(shareKey), types, {shareKey});
    },

    listSchedules: () => {
        const types = {
            request: ActionTypes.REPORT_SCHEDULE_LIST_REQUEST,
            success: ActionTypes.REPORT_SCHEDULE_LIST_SUCCESS,
            failure: ActionTypes.REPORT_SCHEDULE_LIST_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.listSchedules(), types);
    },

    getSchedule: (scheduleId) => {
        const types = {
            request: ActionTypes.REPORT_SCHEDULE_INFO_REQUEST,
            success: ActionTypes.REPORT_SCHEDULE_INFO_SUCCESS,
            failure: ActionTypes.REPORT_SCHEDULE_INFO_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.getSchedule(scheduleId), types, {scheduleId});
    },

    addSchedule: (reportId, data) => {
        const types = {
            request: ActionTypes.REPORT_SCHEDULE_ADD_REQUEST,
            success: ActionTypes.REPORT_SCHEDULE_ADD_SUCCESS,
            failure: ActionTypes.REPORT_SCHEDULE_ADD_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.addSchedule(reportId, data), types, {reportId, data});
    },

    updateSchedule: (scheduleId, data) => {
        const types = {
            request: ActionTypes.REPORT_SCHEDULE_UPDATE_REQUEST,
            success: ActionTypes.REPORT_SCHEDULE_UPDATE_SUCCESS,
            failure: ActionTypes.REPORT_SCHEDULE_UPDATE_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.updateSchedule(scheduleId, data), types, {scheduleId, data});
    },

    deleteSchedule: (scheduleId) => {
        const types = {
            request: ActionTypes.REPORT_SCHEDULE_DELETE_REQUEST,
            success: ActionTypes.REPORT_SCHEDULE_DELETE_SUCCESS,
            failure: ActionTypes.REPORT_SCHEDULE_DELETE_FAILURE
        };
        return CentricDispatcher.dispatchAsync(ReportApi.deleteSchedule(scheduleId), types, {scheduleId});
    }

};
